import React, { FC } from 'react';

const StickyTopWrapper: FC<void> = () => {
  return (
    <div className="header">
      <div id="sticky-top-wrapper" className="sticky-top-wrapper"></div>
    </div>
  );
};

export default StickyTopWrapper;
